import React from 'react';
import PropTypes from 'prop-types';
import Dotdotdot from 'react-dotdotdot';
import { isBrowserIE } from 'helpers/GlobalHelper';

const Description = ({ description = '', theme = {} }) =>
  description && (
    <div className={theme.description}>
      <div className={theme.descriptionText}>
        {isBrowserIE() ? <Dotdotdot clamp={2}>{description}</Dotdotdot> : description}
      </div>
    </div>
  );

export default Description;

Description.propTypes = {
  description: PropTypes.string.isRequired,
  theme: PropTypes.shape({}).isRequired,
};
